
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductMoldsGrid extends _Ext.GridBase<ProductMoldsRow, any> {
        protected getColumnsKey() { return 'OMS.ProductMolds'; }
        protected getDialogType() { return ProductMoldsDialog; }
        protected getIdProperty() { return ProductMoldsRow.idProperty; }
        protected getInsertPermission() { return ProductMoldsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductMoldsRow.localTextPrefix; }
        protected getService() { return ProductMoldsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}